<template>
  <el-table
    :data="rules"
    style="width: 100%"
    :default-sort = "{prop: 'name', order: 'descending'}"
    stripe>

    <el-table-column label="Estado" align="center" prop="enable" sortable>
      <template slot-scope="props">
        <div v-if="props.row.enable">
          <el-tag  class="blob green" size="mini" effect="dark" type="success" >
            Online
          </el-tag>
        </div>
        <div v-else>
          <el-tag size="mini" effect="dark" type="danger">
            Offline
          </el-tag>
        </div>
      </template>
    </el-table-column>

    <el-table-column property="carrier" label="Paqueteria" align="center" >
      <template slot-scope="props">
        <h4>{{ props.row.carrier}}</h4>
      </template>
    </el-table-column>

    <el-table-column label="Regla" prop="name" align="rigth" sortable>
      <template slot-scope="props">
        <h4>
          <i class="el-icon-s-data"></i>
          {{ props.row.name }}
        </h4>
        <small>
          <i class="el-icon-time"></i>
          {{ props.row.updated_at | timeAgo }}
        </small>
      </template>
    </el-table-column>

    <el-table-column label="Proveedor" prop="provider" align="rigth" width="200" sortable>
          <template slot-scope="props">
            <div v-if="props.row.provider && props.row.provider.is_operational">
              <h4>
                <i class="el-icon-postcard"></i>
                {{ props.row.provider.name }}
              </h4>
              <small>
                <i class="el-icon-time"></i>
                {{ props.row.provider.updated_at | timeAgo }}
              </small>
              <span class="line">
              <ul class='loading-frame'>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                </ul>
              </span>
            </div>

            <div v-if="isBackupCredential(props.row.provider)">
              <h4>
                <el-tooltip content="Provedor caido" placement="top">
                  <i class="el-icon-warning" type="danger"></i>
                </el-tooltip>
                {{ getNameFromBackup(props.row.provider.alternative_providers) }}
              </h4>

              <span class="line">
              <ul class='loading-frame--down'>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                  <div class='circle'></div>
                </ul>
              </span>
            </div>
          </template>
        </el-table-column>

    <el-table-column label="Ambiente" align="center"  prop="environment" sortable>>
      <template slot-scope="props">
        <div v-if="props.row.environment == 'production'">
          <el-tag size="mini" effect="plain" type="primary">
            {{ props.row.environment.toUpperCase() }}
          </el-tag>
        </div>
        <div v-else-if="props.row.environment == 'test'">
          <el-tag size="mini" effect="plain" type="danger">
            STAGING
          </el-tag>
        </div>
        <div v-else>
          <el-tag size="mini" effect="plain" type="warning">
            {{ props.row.environment.toUpperCase() }}
          </el-tag>
        </div>
      </template>
    </el-table-column>

    <el-table-column label="Creado" align="center" prop="updated_at" sortable>
      <template slot-scope="props">
        <small>
          <i class="el-icon-date"></i>
          {{ props.row.created_at | formatDate }}
        </small>
      </template>
    </el-table-column>

    <el-table-column align="center">
      <template slot-scope="scope">

        <el-button
          v-if="isSupervisor"
          size="mini"
          icon="el-icon-edit"
          round
          @click="handleEditDistributionData(scope.$index, scope.row)">Editar
        </el-button>

        <el-button
          v-if="isSupervisor && showConfigBtn"
          size="mini"
          icon="el-icon-s-operation"
          round
          @click="clickConfiguration(scope.$index, scope.row)">Configuración
        </el-button>

      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { mapGetters } from 'vuex';
import http from '@/utils/http';
import store from '../observables/carrier';

export default {
  props: {
    ruleType: String,
    showConfigBtn: Boolean,
  },
  data() {
    return {
      rules: [],
    };
  },
  created() {
    this.getTracking();
  },
  computed: {
    ...mapGetters(['isSupervisor']),
    carrier() {
      return store.carrier;
    },
  },
  watch: {
    carrier() {
      this.getTracking();
    },
  },
  methods: {
    async getTracking() {
      const { data } = await http.get(`/rules?carrier=${this.carrier}&type=${this.ruleType}`);
      this.rules = data;
    },
    isBackupCredential(credential) {
      return credential && !credential?.is_operational;
    },
    getBackuptProvider(providers) {
      return providers.find((provider) => provider.enable);
    },
    getNameFromBackup(providers) {
      return this.getBackuptProvider(providers)?.name;
    },
    handleEditDistributionData(index, row) {
      this.$emit('edit', row);
    },
    clickConfiguration(index, row) {
      this.$emit('clickConfiguration', row._id);
    },
  },
};
</script>

<style scoped>

  h4 {
    margin: 2px;
  }
  .el-timeline {
    overflow-y: auto;
    height: 100vh;
    padding-top: 20px;
  }

  pre {
    margin: 0px 30px;
  }

  .bottom {
    text-align: center;
    margin-top: 23px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .line {
    background-color: #d7d7d7;
    position: absolute;
    top: 33%;
    left: -22px;
    transform: scale(0.2);
  }

  .chart {
    font-family: Arial, sans-serif;
    font-size: 12px;
  }

  .svg{
    text-align: center;
    padding: 20px;
    background-color: #8969fe0d;
    margin: 10px 0px;
    border-radius: 4px;
  }

  .axis path,
  .axis line {
    fill: none;
    stroke: #000;
    shape-rendering: crispEdges;
  }

  .tick text{
    font-size: 13px !important;
  }

</style>
